import { Link, useParams } from "react-router-dom";
import { Building2 } from "lucide-react";
import { GlossaryBrowser, GlossaryArticle } from "@/components/glossary/Glossary";

const Body = ({ base }) => {
  const { slug } = useParams();
  return slug ? <GlossaryArticle slug={slug} base={base} /> : (
    <div className="space-y-6">
      <div>
        <div className="text-xs uppercase tracking-wider text-emerald-700 font-semibold mb-1">Bilgi Merkezi</div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>Emlak Sözlüğü & Rehber</h1>
        <p className="text-slate-500 mt-2 max-w-2xl">Tapu, imar ve finans terimlerinin açıklamaları ile EmlakPlus kullanım rehberleri.</p>
      </div>
      <GlossaryBrowser base={base} />
    </div>
  );
};

export function PanelGlossaryPage() {
  return <div data-testid="panel-glossary-page"><Body base="/dictionary" /></div>;
}

export default function PublicGlossaryPage() {
  return (
    <div className="min-h-screen bg-[#f7faf8]" data-testid="public-glossary-page">
      <nav className="sticky top-0 z-30 bg-white/80 backdrop-blur-xl border-b border-slate-200/70">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="glossary-home-link">
            <span className="w-8 h-8 rounded-xl bg-emerald-700 flex items-center justify-center"><Building2 className="w-4 h-4 text-white" /></span>
            <span className="font-extrabold text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>EmlakPlus</span>
          </Link>
          <Link to="/login" data-testid="glossary-login-link" className="px-4 py-2 rounded-full bg-emerald-700 text-white text-sm font-semibold hover:bg-emerald-800 transition-colors">Giriş Yap</Link>
        </div>
      </nav>
      <main className="max-w-6xl mx-auto px-6 py-12 sm:py-16"><Body base="/sozluk" /></main>
    </div>
  );
}
